// extracted by mini-css-extract-plugin
module.exports = {"waveform":"styles_waveform__2l0DD"};